// const CategoryPopoverText = ({ rate }) => {
//     return (
//         <div className="p-5 text-xs bg-white shadow-lg rounded max-w-[250px]">
//             <div className="flex justify-between py-1">
//                 HS Codes are required when sending parcels internationally.
//             </div>
//         </div>
//     )
// }

export function Label({ label }) {
    return (
        <label
            htmlFor={label}
            className="block text-sm font-light leading-6 text-gray-900 inline-flex items-center justify-center text-sm"
        >
            <span>{label}</span>
        </label>
    )
}